import { render, staticRenderFns } from "./FaceNotNeutral.vue?vue&type=template&id=36b16ff8&scoped=true"
var script = {}
import style0 from "./FaceNotNeutral.vue?vue&type=style&index=0&id=36b16ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b16ff8",
  null
  
)

export default component.exports